// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   CropOverlay — image crop for visual search
   ============================================ */

.grb-widget--crop-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: calc(var(--grb-z-index, 9999) + 10);
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--grb-spacing-lg);
}

.grb-widget--crop-overlay.grb-widget--visible {
  display: flex;
}

.grb-widget--crop-container {
  position: relative;
  max-width: 90vw;
  max-height: 70vh;
  cursor: crosshair;
}

.grb-widget--crop-image {
  max-width: 90vw;
  max-height: 70vh;
  object-fit: contain;
  user-select: none;
  -webkit-user-drag: none;
}

.grb-widget--crop-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.grb-widget--crop-actions {
  display: flex;
  gap: var(--grb-spacing-md);
  margin-top: var(--grb-spacing-lg);
}

.grb-widget .grb-widget--crop-search-btn {
  display: flex;
  align-items: center;
  gap: var(--grb-spacing-sm);
  height: 44px;
  padding: 0 var(--grb-spacing-lg);
  background: #fff;
  color: #000;
  font-size: var(--grb-font-size-sm);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  transition: opacity 0.15s ease;
}

.grb-widget .grb-widget--crop-search-btn:hover {
  opacity: 0.85;
}

.grb-widget--crop-search-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.grb-widget--crop-cancel-btn {
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0 var(--grb-spacing-lg);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  font-size: var(--grb-font-size-sm);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  transition: border-color 0.15s ease;
}

.grb-widget--crop-cancel-btn:hover {
  border-color: rgba(255, 255, 255, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/styles/crop-overlay.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,0CAA0C;EAC1C,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":["/* ============================================\n   CropOverlay — image crop for visual search\n   ============================================ */\n\n.grb-widget--crop-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.9);\n  z-index: calc(var(--grb-z-index, 9999) + 10);\n  display: none;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--grb-spacing-lg);\n}\n\n.grb-widget--crop-overlay.grb-widget--visible {\n  display: flex;\n}\n\n.grb-widget--crop-container {\n  position: relative;\n  max-width: 90vw;\n  max-height: 70vh;\n  cursor: crosshair;\n}\n\n.grb-widget--crop-image {\n  max-width: 90vw;\n  max-height: 70vh;\n  object-fit: contain;\n  user-select: none;\n  -webkit-user-drag: none;\n}\n\n.grb-widget--crop-canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.grb-widget--crop-actions {\n  display: flex;\n  gap: var(--grb-spacing-md);\n  margin-top: var(--grb-spacing-lg);\n}\n\n.grb-widget .grb-widget--crop-search-btn {\n  display: flex;\n  align-items: center;\n  gap: var(--grb-spacing-sm);\n  height: 44px;\n  padding: 0 var(--grb-spacing-lg);\n  background: #fff;\n  color: #000;\n  font-size: var(--grb-font-size-sm);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  transition: opacity 0.15s ease;\n}\n\n.grb-widget .grb-widget--crop-search-btn:hover {\n  opacity: 0.85;\n}\n\n.grb-widget--crop-search-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.grb-widget--crop-cancel-btn {\n  display: flex;\n  align-items: center;\n  height: 44px;\n  padding: 0 var(--grb-spacing-lg);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  font-size: var(--grb-font-size-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  transition: border-color 0.15s ease;\n}\n\n.grb-widget--crop-cancel-btn:hover {\n  border-color: rgba(255, 255, 255, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
